/**
 * Names of fields that can be rendered by the Member Email Checker Form Field component.
 */
export var MemberEmailCheckerFormFieldName;
(function (MemberEmailCheckerFormFieldName) {
    /**
     * The Email field renders an input for the email address to be checked.
     */
    MemberEmailCheckerFormFieldName["Email"] = "Email";
})(MemberEmailCheckerFormFieldName || (MemberEmailCheckerFormFieldName = {}));
//# sourceMappingURL=name.js.map